import { connectorThunks } from "../../redux/connectors/connectorsReducer";
import { useAppDispatch, useAppSelectorEnsure, useAutoDispatchAsyncThunk } from "../../redux/hooks";
import { connectorsApi } from "../../services/api/connectors";
import ConnectorForm, { connectorForm } from "./ConnectorForm";
import AsyncContent from "@magicware/dashboard/AsyncContent";
import { useConnectorId } from "../../navigation/connectors";
import { useTranslation } from "react-i18next";

const { useToFormFromModel } = connectorForm.hooks;

export default function ConnectorDetailTab() {
    const api = useAutoDispatchAsyncThunk(connectorThunks.load, useConnectorId());
    return <AsyncContent {...api} component={ConnectorDetailTabLoaded} />;
}

function ConnectorDetailTabLoaded() {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const connectorDetail = useAppSelectorEnsure((state) => state.connectors.detail);
    const initialValues = useToFormFromModel(connectorDetail);
    const onSubmit = async (form: typeof connectorForm.f) => {
        const result = await connectorsApi.forms.update(connectorForm.transform.formTo.update(form, connectorDetail));
        return connectorForm.apiUtils.handleUpdateEntityResult(dispatch, result, form);
    };
    return (
        <ConnectorForm
            onSubmit={onSubmit}
            initialValues={initialValues}
            savePanel={{ successMessage: t("connector-has-been-saved") }}
        />
    );
}
